import { Component, OnInit, LOCALE_ID } from '@angular/core';
import { LoadingPage } from '../../../compartido/cargando/loading';
import { DisponibilidadPlanificacion } from 'npm-modelado-catering';
import { DisponibilidadService } from 'npm-servicios-catering';
import { Constantes } from '../../../compartido/constantes/constantes';
import { DatosSesionService } from '../../servicios/datos-sesion.service';
import { Router, ActivatedRoute } from '@angular/router';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-disponibilidad-planificacion-normal-crear',
  templateUrl: './disponibilidad-planificacion-normal-crear.component.html',
  styleUrls: ['./disponibilidad-planificacion-normal-crear.component.css'],
   providers: [ { provide: LOCALE_ID, useValue: 'fr' } ],
})
export class DisponibilidadPlanificacionNormalCrearComponent extends LoadingPage implements OnInit {

  fechaDisponibilidad: DisponibilidadPlanificacion;
  tituloPagina: string;
  nuevaFechaDisponibilidad: boolean;
  idFechaDisponibilidad: number;
  existe: boolean;
  invalidDates: Array<Date>
  existePlanificacion: any;
  deshabilitarFechaInicio: boolean;
  fechaAuxiliar= new Date();
 

  constructor(private disponibilidadService: DisponibilidadService,
              private datosSesionService: DatosSesionService,
              private router: Router, private routeParams: ActivatedRoute,
             ) { 
    super(false);
  }

  ngOnInit() {
    this.fechaDisponibilidad = new DisponibilidadPlanificacion();
    
    this.nuevaFechaDisponibilidad=false;
    if (this.routeParams.snapshot.queryParams['id']) {
      this.idFechaDisponibilidad = this.routeParams.snapshot.queryParams['id'];
      this.existePlanificacion = this.routeParams.snapshot.queryParams['existePlanificacion'];  
      if(this.existePlanificacion=='true'){
          this.deshabilitarFechaInicio= true;
          
      }else{
          this.deshabilitarFechaInicio= false;
      }

      this.tituloPagina = this._editarFichaDisponibilidadPlanificacion;
      this.disponibilidadService.buscarDisponibilidad(this.idFechaDisponibilidad).then(responseDisponibilidad=>{
        if(responseDisponibilidad){
            let fechaI = responseDisponibilidad.fechaInicio;
            let fechaF= responseDisponibilidad.fechaFin;
            
            this.fechaDisponibilidad.fechaInicio= new Date(fechaI+"T00:00:00");
            this.fechaDisponibilidad.fechaFin = new Date(fechaF+"T00:00:00");
            this.fechaAuxiliar= this.fechaDisponibilidad.fechaFin;
        }
      }); 
      

		} else {

	  		this.tituloPagina = this._crearFichaDisponibilidadPlanificacion;
		  	this.nuevaFechaDisponibilidad = true;
    }
    this.cargarEnviroments();
 
 
  }

  cargarEnviroments(){
    this.disponibilidadService.set_constantes(Constantes);
  }

  async clickGuardar(){
      if(this.validarCamposAlmacencar()){
          await this.buscar();
          this.guardarFechaDisponibilidad();
      }
  }

 buscar(){
   return new Promise(resolve =>{
    this.disponibilidadService.buscar(this.fechaDisponibilidad.fechaFin).then(resultBusqueda=>{
      if(resultBusqueda==true){
         this.existe=true;
        resolve();
      }else{
        this.existe= false
        resolve();
      }
   }).catch(error => this.mostrarMensajeError(error));
   });
    
  }

  guardarFechaDisponibilidad(){
    
        this.fechaDisponibilidad.tipoDisponibilidad=Constantes.TIPO_DISPONIBILIDAD_NORMAL;
        this.fechaDisponibilidad.estaActivo= Constantes.ESTA_ACTIVO_SI;
       
        if(this.nuevaFechaDisponibilidad) {
            if(!this.existe){
              this.disponibilidadService.crear(this.fechaDisponibilidad).then(responseFechaDisponibilidad=>{
                if(responseFechaDisponibilidad){
                  this.redireccionarListadoExito(true);
                }
              }).catch(error => this.mostrarMensajeError(error));
            }else{
              this.mostrarMensajeError(this._validacionDisponibilidadMesExistente)
            }
                
        }else{
            this.fechaDisponibilidad.idDisponibilidadPlanificacion= this.idFechaDisponibilidad;
            if(this.existePlanificacion=='true'){
              if(this.fechaAuxiliar.getDate() <this.fechaDisponibilidad.fechaFin.getDate()){
                    this.modificarDisponibilidad();
              }else{
                this.mostrarMensajeInfo(this._indicacionesEditarFechaSiExisteDependenciaAsociada+this.fechaAuxiliar.getDate()+' de este mes.');
              }
            } else{
                this.modificarDisponibilidad();
            }
            
          
        }
    
     
  }

  modificarDisponibilidad(){
    this.disponibilidadService.modificar(this.fechaDisponibilidad).then(responseFechaDisponibilidad=>{
      if(responseFechaDisponibilidad){
        this.redireccionarListadoExito(true);
      }
    }).catch(error => this.mostrarMensajeError(error));
  }
  redirectListado() {
		this.router.navigate(['/configuracion/disponibilidad-planificacion-normal-listar/']);
  }
  
  redireccionarListadoExito( exito: boolean){
    this.datosSesionService.exitoGuardandoDisponibildadPlanificacion=exito;
		this.router.navigate(['/configuracion/disponibilidad-planificacion-normal-listar/']);
  }

  validarCamposAlmacencar(): boolean{
    try{
      let resultado=true;
      let mensajeError = this._tituloMensajeValidacionGrupal;
      let fechaActual = new Date();
      
      let fechaIni = new Date(this.fechaDisponibilidad.fechaInicio);
      
      fechaIni.setHours(0,0,0,0);
      fechaActual.setHours(0,0,0,0);
     

      if(!this.fechaDisponibilidad || this.fechaDisponibilidad.fechaInicio == null ){
        mensajeError += this._saltoLineaDetalle + this._validarCampoFechaInicioDisponibilidad;
				resultado = false;
      }

      if(!this.fechaDisponibilidad || this.fechaDisponibilidad.fechaFin == null ){
        mensajeError += this._saltoLineaDetalle + this._validarCampoFechaFinDisponibilidad;
				resultado = false;
      }

      if(this.fechaDisponibilidad.fechaInicio > this.fechaDisponibilidad.fechaFin ){
        mensajeError += this._saltoLineaDetalle + this._validarRangoFechaDisponibilidad;
				resultado = false;
      }

      if(this.fechaDisponibilidad.fechaFin && this.fechaDisponibilidad.fechaInicio && 
        this.fechaDisponibilidad.fechaInicio.getMonth()!=this.fechaDisponibilidad.fechaFin.getMonth()){
        mensajeError += this._saltoLineaDetalle + this._validacionFechasIngresadas;
				resultado = false;
      }
      
      
      if(!this.existePlanificacion){
          if(this.fechaDisponibilidad.fechaInicio && fechaIni < fechaActual){
            mensajeError += this._saltoLineaDetalle + this._mensajeDisponibilidadFechaActual;
            resultado=false;
          }
      }
          
      
      if(!resultado){
          this.mostrarMensajeError(mensajeError);
      }
      return resultado;

    }catch(error){
      console.error("ERROR. ValidarCamposAlmacenar", error);
			return false;
    }
    
  }
}
